export enum ContentType {
  FILM = 'film',
  WEB_SERIES = 'web_series',
  MICRO_SERIES = 'micro_series',
  SHORT_FILM = 'short_film',
  VERTICAL_SERIES = 'vertical_series',
}
